import React from "react";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../../backend";
import jwtDecode from "jwt-decode";

const width = window.innerWidth;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderRadius: "10px",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 200,
  bgcolor: "background.paper",
  boxShadow: 100,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderRadius: "10px",
  transform: "translate(-50%, -50%)",
  width: 300,
  height: 200,
  bgcolor: "background.paper",
  boxShadow: 100,
  p: 4,
};

const useStyles = makeStyles({
  text: {
    fontSize: "20px",
    fontWeight: "600",
    margin: "10px 0",
    padding: "",
  },
  btn: {
    margin: "10px 0",
    padding: "15px",
    borderRadius: "10px",
    background: "red",
    color: "white",
    border: "none",
    cursor: "pointer",
  },
  alert: {
    fontSize: "12px",
    color: "red",
    fontWeight: "bold",
  },
});

function DeleteAccount({ open, setOpen }) {
  const handleClose = () => {
    setOpen(false);
  };
  const navigate = useNavigate();

  const classes = useStyles();

  const { role } = jwtDecode(JSON.parse(localStorage.getItem("_access_token")));

  const handleDelete = async () => {
    let config = {
      method: "delete",
      url: `${API}/user/deleteAcc`,
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("_access_token")
        )}`,
        "Content-Type": "application/json",
      },
    };

    const res = await axios(config);

    console.log(res.data);

    if (res.data.status === "success") {
      localStorage.removeItem("_access_token");
      navigate("/signup");
    } else {
      alert("Some Error Occured. Try Again Later");
    }
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={width > 768 ? style : style2}>
            <Typography style={{ fontWeight: "bold", color: "#000" }}>
              {width > 768 ? (
                <>Are you sure to delete this account?</>
              ) : (
                <> Delete this account?</>
              )}
            </Typography>
            {role === "creator" && (
              <Typography style={{ fontWeight: "bold", color: "#000", marginTop: 8 }}>
                All your playlists will also be deleted
              </Typography>
            )}

            <button className={classes.btn} onClick={handleDelete}>
              Delete Permanently
            </button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default DeleteAccount;
